define('collection/ClassesCollection',['require','lib/collection/BaseCollection','model/ClassesModel','model/TimeSlotModel','model/GroupedTimeSlotsModel','backbone','Config'],function (require) {

    var BaseCollection = require('lib/collection/BaseCollection');
    var ClassesModel = require('model/ClassesModel');
    var TimeSlotModel = require('model/TimeSlotModel');
    var GroupedTimeSlotsModel = require('model/GroupedTimeSlotsModel');
    var Backbone = require('backbone');
    var Config = require('Config');

    /**
     * Classes collection
     *
     * @class ClassesCollection
     */
    return BaseCollection.extend({

        url: '/booking/classes/',
        model: ClassesModel,
        _timeCollection: new Backbone.Collection(),
        _providerCollection: new Backbone.Collection(),

        /**
         * Returns collection of available timeslots
         *
         * @return {Backbone.Collection}
         */
        getTimeCollection: function () {
            var min = null;
            var max = null;
            var date = null;
            this.each(function (model) {
                var from = new Time(model.get('from'));
                var to = new Time(model.get('to'));

                if (max === null || to.getInteger() > max) {
                    max = to.getInteger();
                }
                if (min === null || from.getInteger() < min) {
                    min = from.getInteger();
                }
                date = model.get('date');
            });

            this._buildTimeCollection(min, max, date);

            return this._timeCollection;
        },

        /**
         * Returns timeslots grouped by provider
         *
         * @param array providers
         * @return {Backbone.Collection}
         */
        getProviderCollection: function (providers) {
            var models = {};
            this.each(function (model) {
                if (providers && _.indexOf(providers, model.get('provider_id') + '') === -1) {
                    return;
                }
                if (!models[model.get('provider_id')]) {
                    models[model.get('provider_id')] = new GroupedTimeSlotsModel({
                        'provider_id': model.get('provider_id'),
                        'collection': new Backbone.Collection()
                    });
                }

                models[model.get('provider_id')].get('collection').add(model);
            });

            var result = [];
            _.each(providers, function (id) {
                if (!models.hasOwnProperty(id)) {
                    return;
                }
                result.push(models[id]);
            }, this);

            this._providerCollection.reset(result);

            return this._providerCollection;
        },

        /**
         * Builds available time slots
         *
         * @param Integer from
         * @param Integer to
         * @param String date
         * @private
         */
        _buildTimeCollection: function (from, to, date) {
            var timeframe = Config.getInstance().getTimeFrame();

            var models = [];
            for (var slot = from; slot < to; slot += timeframe) {
                var time = new Time(slot);
                var timeStr = time.getFormattedTime('24hr');

                models.push(new TimeSlotModel({
                    'id': date + ' ' + timeStr,
                    'time': timeStr,
                    'date': date
                }));
            }
            this._timeCollection.reset(models);
        }

    });

});
